export default __webpack_public_path__ + "static/media/hallowkitty.e2c5f07b.jpg";